import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
} from "@mui/material";
import React, { useState } from "react";
import moment from "moment";
import LetterTemplateHeader from "../../documents/LetterTemplateHeader";
import LetterTemplateFooter from "../../documents/LetterTemplateFooter";

const DraftAuthorizationByMinistry = (props) => {
  const {
    showAuthorizationPermit,
    setShowAuthorizationPermit,
    dialogActions,
    loading,
    minstryLetterReferenceNo,
    draftAuthorizationSubjectByMinistry,
    draftAuthorizationContentByMinistry,
    headOfInstitution,
    signContent,
    isMifotraEntitySector,
    disableToEditLetterHeader,
    entitySectorId,
    loadFooterContent,
    planningEntityId
  } = props;

  const onClose = () => {
    setShowAuthorizationPermit(false);
  };
  const [letterCustomization, setLetterCustomization] = useState(null);

  const loadHeaderContent = (data) => {
    // console.log(data);
    setLetterCustomization(data);
  };

  return (
    <>
      <Dialog
        //onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showAuthorizationPermit}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-primary">
          <div className="row">
            <div className="col-10">
              Request the authorization to conduct a training
            </div>
            <div className="col-2">
              <div className="row">
                <div className="col">
                  {!dialogActions && (
                    <IconButton
                      aria-label="close"
                      onClick={onClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 2,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <span className="material-icons">close</span>
                    </IconButton>
                  )}
                </div>
              </div>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className="mt-0 mx-4" dividers>
          {dialogActions && loading && (
            <div className="col-12">
              <LinearProgress />
            </div>
          )}
          <div className="letterMainContent">
            <div className="letter">
              <LetterTemplateHeader
                disableToEdit={true}
                entitySectorId={entitySectorId}
                planningEntityId={planningEntityId}
                loadHeaderContent={(data) => loadHeaderContent(data)}
              />
              <div className="subletterhead">
                <table>
                  <tr>
                    <td style={{ width: "70%" }}></td>
                    <td style={{ width: "30%" }}>
                      <p
                        className="date w-100"
                        style={{
                          fontWeight: "bold",
                          float: "left",
                          textAlign: "left",
                          fontSize:
                            (letterCustomization?.styles?.fontSize || "12") +
                            "px!important",
                          fontFamily:
                            letterCustomization?.styles?.fontFamily ||
                            "Times New Roman!important",
                          lineHeight: letterCustomization?.styles?.lineHeight,

                          lineSpacing: `${
                            letterCustomization?.styles?.lineSpacing || 0
                          }px!important`,
                        }}
                      >
                        Kigali, on {moment(new Date()).format("LL")}
                      </p>
                      <p
                        className="reference"
                        style={{
                          fontWeight: "bold",
                          float: "left",
                          textAlign: "left",
                          position: "relative",
                          top: "-22px",
                          fontSize:
                            (letterCustomization?.styles?.fontSize || "12") +
                            "px!important",
                          fontFamily:
                            letterCustomization?.styles?.fontFamily ||
                            "Times New Roman!important",
                          lineHeight: letterCustomization?.styles?.lineHeight,

                          lineSpacing: `${
                            letterCustomization?.styles?.lineSpacing || 0
                          }px!important`,
                        }}
                      >
                        N<sup>o</sup>:{" "}
                        {minstryLetterReferenceNo
                          ? minstryLetterReferenceNo
                          : "........."}
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <div className="recipient">
                {/* <!-- Recipient's name and address go here --> */}

                <p
                  style={{
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,
                  }}
                >
                  {isMifotraEntitySector ? (
                    <>
                      Chief Skills Officer <br />
                      <strong>Rwanda Development Board</strong>
                    </>
                  ) : (
                    <>Honorable Minister of Public Service and Labour</>
                  )}
                  <br />
                  <span
                    style={{
                      position: "relative",
                      top: "6px",
                      fontWeight: "bold",
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                      lineHeight: letterCustomization?.styles?.lineHeight,

                      lineSpacing: `${
                        letterCustomization?.styles?.lineSpacing || 0
                      }px!important`,
                    }}
                  >
                    KIGALI
                  </span>
                </p>
              </div>
              <div
                className="content2"
                style={{
                  fontSize:
                    (letterCustomization?.styles?.fontSize || "12") +
                    "px!important",
                  fontFamily:
                    letterCustomization?.styles?.fontFamily ||
                    "Times New Roman!important",
                  lineHeight: letterCustomization?.styles?.lineHeight,

                  lineSpacing: `${
                    letterCustomization?.styles?.lineSpacing || 0
                  }px!important`,
                }}
              >
                {/* <!-- Letter content goes here --> */}
                {isMifotraEntitySector ? (
                  <>
                    <p>Dear Chief Skills Officer,</p>
                  </>
                ) : (
                  <>
                    <p>Honorable Minister,</p>
                  </>
                )}
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,
                  }}
                >
                  Re:
                  {draftAuthorizationSubjectByMinistry
                    ? draftAuthorizationSubjectByMinistry
                    : "Request the authorization to conduct a training"}
                </p>
                <div
                  style={{
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,

                    textAlign: letterCustomization?.styles?.textAlign || "",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: draftAuthorizationContentByMinistry
                      ? draftAuthorizationContentByMinistry
                      : "",
                  }}
                ></div>
                {/* 0864297531 */}
              </div>
              <div className="signature2">
                <p
                  style={{
                    position: "relative",
                    paddingBottom: "15px",
                    fontWeight: 800,
                    color: "red",
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,
                  }}
                >
                  {signContent ? (
                    signContent
                  ) : (
                    <table className="mt-3">
                      <tr>
                        <td
                          style={{
                            width: "10%",
                            textAlign: "left",
                            paddingLeft: "10px",
                            fontSize:
                              (letterCustomization?.styles?.fontSize || "12") +
                              "px!important",
                            fontFamily:
                              letterCustomization?.styles?.fontFamily ||
                              "Times New Roman!important",
                            lineHeight: letterCustomization?.styles?.lineHeight,

                            lineSpacing: `${
                              letterCustomization?.styles?.lineSpacing || 0
                            }px!important`,
                          }}
                        >
                          <span className="d-block text-danger">
                            Not signed
                          </span>
                        </td>
                        <td
                          style={{
                            width: "20%",
                            textAlign: "left",
                            fontSize:
                              (letterCustomization?.styles?.fontSize || "12") +
                              "px!important",
                            fontFamily:
                              letterCustomization?.styles?.fontFamily ||
                              "Times New Roman!important",
                            lineHeight: letterCustomization?.styles?.lineHeight,

                            lineSpacing: `${
                              letterCustomization?.styles?.lineSpacing || 0
                            }px!important`,
                          }}
                        ></td>
                      </tr>
                    </table>
                  )}
                </p>
                <p
                  className="mt-4"
                  style={{
                    fontSize: "13px",
                    fontWeight: 800,
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,
                  }}
                >
                  {headOfInstitution.title
                    ? headOfInstitution.title + ". "
                    : ""}
                  {headOfInstitution?.firstName || ""}{" "}
                  {headOfInstitution?.lastName || ""}
                </p>

                <p
                  style={{
                    fontWeight: 800,
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,
                  }}
                >
                  {headOfInstitution?.positionName || ""}
                </p>
                {!!headOfInstitution?.canAddInstitutionName ? (
                  <p
                    style={{
                      fontWeight: 800,
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                      lineHeight: letterCustomization?.styles?.lineHeight,

                      lineSpacing: `${
                        letterCustomization?.styles?.lineSpacing || 0
                      }px!important`,
                    }}
                  >
                    {headOfInstitution?.institutionName}
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="mt-5 pt-5">
                <LetterTemplateFooter
                  disableToEdit={true}
                  loadFooterContent={loadFooterContent}
                />
              </div>
            </div>
          </div>
        </DialogContent>
        {dialogActions && (
          <DialogActions className="d-flex justify-content-center py-4">
            {dialogActions}
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};
export default DraftAuthorizationByMinistry;
